module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Few men have contributed more to the well-being and comfort of modern man than Thomas Alva Edison. The glow of the electric light, and with it the waves of immortal music come right into the homes of the world’s great masses, through the inventive genius of this unassuming tinkerer; and through his efforts the theatre on the screen reaches into every hamlet on the globe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With his more than one thousand inventions, Edison symbolizes the inauguration of the electro-industrial era of our time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Edison was almost Franklinian in his defiance of the doctrines of pure science. He was an experimenter and a practical man more than an ingenious theoretician. His inventions were the product of a methodical and prodding mind. There were no sudden flashes of accidental discovery in his realm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His book knowledge was scattered, sporadic and unsystematic; he was almost entirely self-educated. He would read the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Police Gazette")]), _vm._v(" one hour and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Higher Mathematics")]), _vm._v(" the next. A man of the people, working for a living and for his “experimental equipment,” from the age of twelve on his mind was perennially active for the people and their "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("welfare. He was, without doubt, in the words of Marconi, “one of the world’s greatest benefactors.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The editor has endeavored, in this volume, to present to the reader a selection of Edison’s social and philosophic ideas taken from the available notes, statements and observations of the inventor. The reader will find that many of Edison’s casual remarks made decades ago have a definite contemporary significance. His propositions in ethics, philosophy, music and education show a rare combination of whimsey and deep sincerity.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("D. D. R.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60cc67fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Preface.vue
// module id = 75
// module chunks = 0